<template>
  <div id="app">
    <FotoHeader
      title="EL ARCHIVO"
    />
    <PageLoader />
    <router-view :key="$route.fullPath"></router-view>
    <FotoFooter />
  </div>
</template>

<script>
import FotoHeader from './components/FotoHeader'
import FotoFooter from './components/FotoFooter'
import PageLoader from './components/PageLoader'


export default {
  name: 'App',
  components: {
    FotoHeader,
    FotoFooter,
    PageLoader
  },
};
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;600;700;900&display=swap');
  @import url('https://pro.fontawesome.com/releases/v5.10.0/css/all.css');

a,
a:visited,
a:active {
  color: #000000;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
}
a:hover {
  color: #000000;
  opacity: 0.5;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
}
.foto-body {
  min-height: 100vw;
}
.main-module {
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.row .col {
  padding: 0!important;
}

@media only screen and (max-width:1255px){
    .img-aliados{
        height: 120px;
        padding: 10px;
    }
}


@media only screen and (max-width: 1150px){

    .menu{
        display: none;
    }
    .res-menu{
        display: inline !important;
        font-size: 30px;
        padding-top: 10px;
        cursor: pointer;
    }

}

@media only screen and (max-width: 640px){

    .logo-text {
        width: 62px;
        font-family: Raleway;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding-left: 9px;
        padding-top: 11px;
    }

    .search {
        width: 160px;
    }

    .title-about{
        width: 100%;
        font-size: 25px;
    }

    .about-afu{
        width: 100%;
        height: 380px;
    }
    .card-post{
        height: auto;
    }
    .img-gradient, .card-post-img-2{
        height: 180px;
    }


    .yellow{
        width: 100% !important;
    }
    .home-slider{
        width: 100%;
        height: auto;
    }
    .slideshow-container {
        height: auto !important;
    }
    .img-aliados{
        height: 90px;
        padding: 1px;
    }
    .footer-container{
        padding-left: 40px;
        flex-direction: column;
    }
    footer{
        height: auto;
    }
}
</style>
